<template>
  <div class="vip-list-detail">
    <div class="detail-content">
      <div class="header-title">
        <h2>用户详情</h2>
      </div>
      <div class="info" v-for="(item, index) in info" :key="index">
        <div class="info-title">
          <span class="icon"></span>
          <span class="info-title-text">{{item.title}}</span>
        </div>
        <ul>
          <el-row v-for="(rowItem, rowIndex) in item.infoRow" :key="rowIndex">
            <li class="info-item" v-for="(liItem,liIndex) in rowItem.li" :key="liIndex">
              <span class="label">{{liItem.label}}</span>
              <span v-if="liItem.key == 'registerTime'" class="value">
                {{$moment(detail[liItem.key]).format('YYYY/MM/DD HH:mm:ss')}}
              </span>
              <template v-else-if="liItem.key == 'avatar'">
                <div class="img-box" v-if="detail[liItem.key]">
                  <el-image :src="detail[liItem.key]" class="img" fit="contain" />
                </div>
                <span v-else>-</span>
              </template>
              <span v-else class="value">
                <span v-if="liItem.key != 'labels'">{{detail[liItem.key]?detail[liItem.key]:"-"}}</span>
                <span v-else>
                  <span class="label-box" v-for="(labelItem, labelIndex) in detail[liItem.key]" :key="labelIndex">
                    <el-tooltip placement="top">
                      <div slot="content">创建时间：{{ labelItem.created }}<br/>
                      {{ labelItem.name == '黑名单' ? labelItem.startTime? '拉黑时间：'+labelItem.startTime+'-'+labelItem.endTime : '拉黑时间：永久拉黑' : ''}}<br/>
                      {{ labelItem.name == '黑名单' ? labelItem.reason ? '原因：'+ labelItem.reason : '原因：' : ''}}<br/>
                      </div>
                    <span>{{ labelItem.name }}</span>
                  </el-tooltip>
                  <img @click="deleteLabel2(labelItem)" class="delete" src="../../../assets/member_images/delete.png" alt="" srcset="">
                    <!-- <auth-button auth="member:user:label:delete">
                      <img @click="deleteLabel(labelItem)" class="delete" src="../../../assets/member_images/delete.png" alt="" srcset="">
                    </auth-button> -->
                  </span>
                </span>
                <auth-button auth="user:phone:read">
                  <el-button v-if="liItem.key === 'phone' && !showPhone" type="text" class="look-phone" @click="onLookPhone(true)">查看</el-button >
                  <el-button v-if="liItem.key === 'phone' && showPhone" type="text" class="look-phone" @click="onLookPhone(false)">隐藏</el-button >
                </auth-button>
                <auth-button auth="member:point:read">
                  <el-button v-if="liItem.key === 'memberPoint'" type="text" class="look-phone font14" @click="goFlow">查看流水</el-button >
                </auth-button>
                <auth-button auth="member:label">
                  <el-button v-if="liItem.key === 'labels'" type="primary" class="add-labels-btn" @click="openDialog">新增标签</el-button >
                </auth-button>
              </span>
            </li>
          </el-row>
        </ul>
      </div>
    </div>
    <div class="footer">
      <el-button type="default" @click="goback">返回</el-button>
    </div>
    <Dialog :maskClose="false" :dialogShow="dialogShow" title="新增标签">
      <template>
        <div class="add-label">
          <el-form :hide-required-asterisk="true" ref="form" :model="form" label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择标签" prop="labelId" :rules="[{ required: true, message: '标签不能为空'},]">
                  <el-select filterable v-model="form.labelId" multiple placeholder="请选择标签" @change="queryLabel()">
                    <el-option
                      v-for="(item, index) in labelOptions"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="isPermanent">
                <el-form-item label="是否设置时间" prop="permanent" :rules="[{ required: true, message: '时间不能为空'},]">
                  <el-radio-group v-model="form.permanent">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否（永久拉黑）</el-radio>
              </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="form.permanent == 1">
                <el-form-item  prop="userIds" label="">
                  <el-date-picker v-model="form.continuityTime" type="datetimerange" value-format="timestamp" style="width:100%"
                start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="24"  v-if="isPermanent">
                <el-form-item label="原因" prop="labelId">
                  <el-input placeholder="请输入原因" v-model="form.reason" type="textarea" maxlength="1000" :autosize="{ minRows: 5, maxRows: 20}" show-word-limit ></el-input>
                </el-form-item>
              </el-col>

            </el-row>
          </el-form>
          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => {dialogShow = false}">取消</el-button>
              <el-button type="primary" :loading="dialogLoading"  class="determine" @click="determine">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getMemberDetail, api_deleteUserLabel, api_postDeleteLabeled  } from '@/api/member'
import { api_getListLabel, api_getLabeled, api_getUserPhone} from '@/api/common'
import Dialog from "@/components/Dialog/index";
import aes from '@/common/aes.js'
export default {
  name: "vipListDetail",
  components: {
    AuthButton,
    Dialog
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          let now = new Date();
          let year = now.getFullYear(); // 年
          let month = now.getMonth() + 1; // 月
          let day = now.getDate(); // 日
          let dates = new Date(year, month, 0).getDate();
          // 时间限制在当天后才能选则
          return time.getTime() <= new Date(`${year}-${month}-${day-1}`).getTime();
        },},
      phone: '',
      showPhone: false,
      labelOptions: [],
      permanentID:'',
      isPermanent:false,
      dialogShow: false,
      form: {
        labelId: [],
        permanent:2,
        reason:'',
      },
      dialogLoading: false,
      detail: {},
      labels: [],
      info: [{
        title: '基础信息',
        infoRow: [{
          li: [{
            label: '会员头像：',
            key: 'avatar'
          }]
        },{
          li: [{
            label: '会员ID：',
            key: 'refId'
          },{
            label: '注册来源：',
            key: 'platform'
          }]
        },{
          li: [{
            label: '昵称：',
            key: 'nickname'
          },{
            label: '姓名：',
            key: 'name'
          }]
        },{
          li: [{
            label: '会员生日：',
            key: 'birthday'
          },
          {
            label: '注册时间：',
            key: 'registerTime'
          }]
        },
        {
          li: [{
            label: '性别：',
            key: 'sex'
          },{
            label: '手机号码：',
            key: 'phone'
          }]
        },
        {
          li: [{
            label: '地址：',
            key: 'locationDetail'
          }]
        },
        ]
      },{
        title: '会员信息',
        infoRow: [{
          li: [{
            label: '会员等级：',
            key: 'levelName'
          },{
            label: '会员积分：',
            key: 'memberPoint'
          }]
        },{
          li: [{
            label: '会员标签：',
            key: 'labels'
          }]
        }]
      }]
    };
  },
  created () {
    this.getDetailDate()
    this.getListLabel()
  },
  methods: {
    goback () {
      this.$router.go(-1)
    },
    deleteLabel (item) {
      this.$baseConfirm(
        '是否确认删除该标签',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_deleteUserLabel({labelId: item.id, userId: this.$route.query.id})
          this.$baseMessage('删除成功', 'success')
          this.getDetailDate()
        }
      )
    },
    //删除标签
    deleteLabel2 (item) {
      this.$baseConfirm(
        '是否确认删除该标签',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          console.log(item)
          await api_postDeleteLabeled({labelId: item.id, userId: this.$route.query.id})
          this.$baseMessage('删除成功', 'success')
          this.getDetailDate()
          this.getListLabel()
        }
      )
    },
    async getDetailDate() {
      const data = await api_getMemberDetail({id: this.$route.query.id})
      this.phone = data.phone
      this.detail = JSON.parse(JSON.stringify(data))
      try {
        this.labels = data.labels.map((item) => {
          return item.id
        })
      } catch (error) {
        this.labels = []
      }
      // 过滤出已经增加的标签
      this.labelOptions = this.labelOptions.filter((item) => {
        return (!this.labels.includes(item.id))
      })
    },
    async getListLabel() {
      this.labelOptions = await api_getListLabel()
      //获取黑名单id方便查询
      this.labelOptions.forEach(item =>{
        if(item.name == "黑名单"){
          this.permanentID = item.id
        }
      })
    },
    goFlow () {
      this.$router.push({
        path: '/accumulationScore/flow?userId=' + this.detail.id
      })
    },
    openDialog () {
      if(this.labelOptions.length <= 0){
        this.$baseMessage('无新增标签可选', 'info')
      }else{
        this.isPermanent = false
        this.dialogShow = true
      }
    },
    // 点击查看手机号
    async onLookPhone(show) {
      this.showPhone = show
      if(show){
        try {
          const {phone} = await api_getUserPhone({id: this.$route.query.id})
          this.detail.phone = aes.decrypt(phone)
        } catch (error) {}
      }else{
        this.detail.phone = this.phone
      }
    },
    determine () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.dialogLoading = true
          try {
            let data = {
              userId: [this.$route.query.id],
              labelId: this.form.labelId,
            }
            if(this.isPermanent){
              data.permanent = this.form.permanent
              data.reason = this.form.reason
              if(data.permanent == 1){
                data.startTime = this.form.continuityTime[0]
                data.endTime = this.form.continuityTime[1]
              }
            }
            console.log(data)
            await api_getLabeled(data)
            this.dialogLoading = false
            this.dialogShow = false
            this.$baseMessage('操作成功', 'success')
            this.getDetailDate()
          } catch (error) {
            this.dialogLoading = false
          }
        } else {
          return false
        }
      })
    },
    //循环标签名判断是否选中黑名单标签
    queryLabel(){
      this.isPermanent = false
      this.form.labelId.forEach(item =>{
        if(this.permanentID == item){
          this.isPermanent = true
        }
      })
    }
  },
  computed: {},
  watch: {
    dialogShow(newValue) {
      if (!newValue) {
        this.form = {
          labelId: []
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.vip-list-detail {
  padding: 0 20px;
  padding-bottom: 100px;
  .detail-content{
    .header-title{
      height: 84px;
      border-bottom: 1px solid #ccc;
      h2{
        line-height: 84px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        margin: 0;
      }
    }
    .info{
      margin-top: 30px;
      padding-bottom: 30px;
      border-bottom: 1px solid #ccc;
      .info-title{
        display: flex;
        align-items: center;
        .icon{
          width: 5px;
          height: 25px;
          background: #05C8AF;
          border-radius: 2px;
          display: inline-block;
        }
        .info-title-text{
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
          height: 25px;
          margin-left: 10px;
        }
      }
      ul{
        margin: 0;
        padding: 0;
        .info-item{
          margin: 0;
          padding: 0;
          list-style: none;
          margin-top: 30px;
          font-size: 14px;
          color: #333;
          display: inline-block;
          .label{
            width: 140px;
            text-align: right;
            display: inline-block;
            vertical-align: top;
          }
          .value{
            width: 280px;
            display: inline-block;
            button{
              padding: 0;
              margin-left: 10px;
              height: 16px;
              line-height: 16px;
            }
            .look-phone{
              font-size: 12px;
              color: #1a5cf5;
              margin-left: 10px;
            }
            .font16{
              font-size: 14px;
            }

          }

          .img-box {
            display: inline-block;
            width: 150px;
            height: 150px;
            border: 1px solid #ccc;
            border-radius: 2px;

            .img {
              width: 150px;
              height: 150px;
            }
          }
        }
      }
    }
    .info:last-child{
      border: 0;
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    height: 80px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    padding-left: 70px;
    padding-top: 23px;
    box-sizing: border-box;
    bottom: 0;
    button{
      padding: 0;
      height: 34px;
      text-align: center;
      width: 110px;
      font-size: 16px;
      color: #666666;
      border: 0;
    }
  }
  .add-label{
    margin-top: 22px;
    ::v-deep{
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
      }
    }
    .el-select{
      width: 100%;
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
  .add-labels-btn{
    height: 26px !important;
    line-height: 26px !important;
    padding: 0 15px !important;
    min-width: 90px !important;
    border-radius: 4px;
    vertical-align: middle;
    margin-left: 0 !important;
  }
  .label-box{
    min-width: 70px;
    height: 25px;
    background: rgba(5,200,175,0.2);
    border-radius: 4px;
    border: 1px solid #05C8AF;
    display: inline-block;
    font-size: 12px;
    color: #05C8AF;
    line-height: 25px;
    text-align: center;
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
    .delete{
      position: absolute;
      top: -15px;
      right: -10px;
      cursor: pointer;
      display: none;
    }
  }
  .label-box:hover{
    .delete{
      display: block;
    }
  }
  ::v-deep{
    .Dialog{
      .content{
        min-height: 280px;
      }
    }
  }
}
</style>
